import { NewbuildingContactsContainer } from './NewbuildingContactsContainer';

// eslint-disable-next-line import/no-default-export
export default NewbuildingContactsContainer;
